import { Box, Button, Input, Stack, Text } from "@chakra-ui/react";
import React, { useRef } from "react";
import {
  InsightsProduct,
  SharedInsightsProduct,
} from "../../../graphql/fragments/product";
import { BsUpload } from "react-icons/bs";

interface UploadProductImageProps {
  setImageFiles: React.Dispatch<React.SetStateAction<FileList | null>>;
  imageFiles: FileList | null;
  product: SharedInsightsProduct | InsightsProduct | null;
}

const UploadProductImage = (props: UploadProductImageProps): JSX.Element => {
  const { setImageFiles, product } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  const placeholderImg = `${location.protocol}//${location.host}/static/images/image-upload-placeholder-icon.svg`;

  return (
    <Stack padding={3} border="1px solid #b6b9bd" borderRadius={5}>
      <Text color="#6c757d">Product Image</Text>
      <Box
        height="250px"
        width="250px"
        border="1px solid #d8e0e8"
        display="flex"
        justifyContent="center"
        padding={product?.logo ? "0px" : "40px"}
      >
        <img src={product?.logo || placeholderImg} ref={imageRef} />
      </Box>
      <Input
        name="image"
        accept=".jpg, .jpeg, .png, .gif"
        type="file"
        hidden
        ref={fileInputRef}
        onChange={(e) => {
          setImageFiles(e.target.files);
          if (e.target.files && imageRef.current) {
            imageRef.current.src =
              URL.createObjectURL(e.target.files[0]) || placeholderImg;
          }
        }}
      />
      <Button
        colorScheme="blue"
        onClick={() => fileInputRef.current?.click()}
        rightIcon={<BsUpload />}
      >
        Upload Image
      </Button>
      <Text fontSize="xs">Use a square image</Text>
      <Text fontSize="xs">minimum (250x250)</Text>
      <Text fontSize="xs">maximum (500x500)</Text>
    </Stack>
  );
};

export default UploadProductImage;
